import React, { createContext, useContext, useState } from 'react'

const SearchContext = createContext<{
  searchText: string
  setSearchText: (value: string) => void
} | null>(null)

export const useSearchContext = () => {
  const context = useContext(SearchContext)
  if (!context) throw new Error('useSearchContext must be inside SearchContextProvider')
  return context
}

export const SearchContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [searchText, setSearchText] = useState<string>('')

  return (
    <SearchContext.Provider value={{ searchText, setSearchText }}>
      {children}
    </SearchContext.Provider>
  )
}
